import * as React from 'react';
interface ISearchNone {
    style?: {}; // inline style obj
    color?: string; // #000000
}
const SearchNone: React.FC<ISearchNone> = (props) => {
    const { color } = props;
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="83" height="44" viewBox="0 0 83 44">
            <g fill="none" fill-rule="evenodd">
                <g>
                    <g transform="translate(-609 -215) translate(609 215)">
                        <circle cx="22" cy="22" r="22" fill="#D8EDF7" />
                        <circle cx="61" cy="39" r="2" fill="#3EA5D9" />
                        <circle cx="71" cy="39" r="2" fill="#3EA5D9" />
                        <circle cx="81" cy="39" r="2" fill="#3EA5D9" />
                        <path
                            fill="#3EA5D9"
                            d="M42.413 40.742l-8.761-8.765c1.57-2.142 2.412-4.732 2.4-7.388-.03-6.933-5.638-12.549-12.57-12.589-3.318-.015-6.504 1.298-8.849 3.645C12.29 17.993 10.981 21.181 11 24.5c.03 6.934 5.638 12.55 12.572 12.59 2.667.012 5.266-.84 7.409-2.426l.01-.007 8.752 8.758c.474.497 1.179.698 1.843.525.664-.172 1.182-.69 1.354-1.355.172-.664-.03-1.369-.527-1.842zM23.61 34.857c-5.693-.033-10.298-4.637-10.323-10.322-.015-2.72 1.059-5.334 2.984-7.259 1.924-1.925 4.54-3.001 7.264-2.99 5.693.033 10.298 4.637 10.323 10.322.015 2.72-1.059 5.334-2.984 7.259-1.924 1.925-4.54 3.001-7.264 2.99z"
                        />
                        <path
                            stroke="#2896CC"
                            stroke-linecap="round"
                            stroke-width="2"
                            d="M30.844 21.328c-.582-2.033-1.989-3.398-3.978-4.066"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default SearchNone;
